"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";
import { useRef } from "react";
interface ScrollAnimationProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: "up" | "down" | "left" | "right";
  stagger?: boolean;
}
export function ScrollAnimation(t0) {
  const $ = _c(39);
  const {
    children,
    className: t1,
    delay: t2,
    direction: t3,
    stagger: t4
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const delay = t2 === undefined ? 0 : t2;
  const direction = t3 === undefined ? "up" : t3;
  const stagger = t4 === undefined ? false : t4;
  const ref = useRef(null);
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      once: true,
      margin: "-50px"
    };
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const isInView = useInView(ref, t5);
  const shouldReduceMotion = useReducedMotion();
  if (shouldReduceMotion) {
    let t6;
    if ($[1] !== children || $[2] !== className) {
      t6 = <div ref={ref} className={className}>{children}</div>;
      $[1] = children;
      $[2] = className;
      $[3] = t6;
    } else {
      t6 = $[3];
    }
    return t6;
  }
  let t6;
  if ($[4] !== direction) {
    t6 = () => {
      switch (direction) {
        case "up":
          {
            return {
              y: 30,
              x: 0
            };
          }
        case "down":
          {
            return {
              y: -30,
              x: 0
            };
          }
        case "left":
          {
            return {
              x: 30,
              y: 0
            };
          }
        case "right":
          {
            return {
              x: -30,
              y: 0
            };
          }
        default:
          {
            return {
              y: 30,
              x: 0
            };
          }
      }
    };
    $[4] = direction;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const getInitialPosition = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      opacity: 0
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== delay) {
    t8 = {
      hidden: t7,
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.1,
          delayChildren: delay
        }
      }
    };
    $[7] = delay;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const containerVariants = t8;
  let t9;
  if ($[9] !== getInitialPosition) {
    t9 = {
      opacity: 0,
      ...getInitialPosition(),
      filter: "blur(4px)"
    };
    $[9] = getInitialPosition;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [0.22, 1, 0.36, 1];
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      opacity: 1,
      x: 0,
      y: 0,
      filter: "blur(0px)",
      transition: {
        duration: 0.6,
        ease: t10 as const
      }
    };
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t9) {
    t12 = {
      hidden: t9,
      visible: t11
    };
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const itemVariants = t12;
  if (stagger) {
    const t13 = isInView ? "visible" : "hidden";
    let t14;
    if ($[15] !== children || $[16] !== itemVariants) {
      let t15;
      if ($[18] !== itemVariants) {
        t15 = child => <motion.div variants={itemVariants}>{child}</motion.div>;
        $[18] = itemVariants;
        $[19] = t15;
      } else {
        t15 = $[19];
      }
      t14 = React.Children.map(children, t15);
      $[15] = children;
      $[16] = itemVariants;
      $[17] = t14;
    } else {
      t14 = $[17];
    }
    let t15;
    if ($[20] !== className || $[21] !== containerVariants || $[22] !== t13 || $[23] !== t14) {
      t15 = <motion.div ref={ref} variants={containerVariants} initial="hidden" animate={t13} className={className}>{t14}</motion.div>;
      $[20] = className;
      $[21] = containerVariants;
      $[22] = t13;
      $[23] = t14;
      $[24] = t15;
    } else {
      t15 = $[24];
    }
    return t15;
  }
  let t13;
  if ($[25] !== getInitialPosition) {
    t13 = {
      opacity: 0,
      ...getInitialPosition(),
      filter: "blur(4px)"
    };
    $[25] = getInitialPosition;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== getInitialPosition || $[28] !== isInView) {
    t14 = isInView ? {
      opacity: 1,
      x: 0,
      y: 0,
      filter: "blur(0px)"
    } : {
      opacity: 0,
      ...getInitialPosition(),
      filter: "blur(4px)"
    };
    $[27] = getInitialPosition;
    $[28] = isInView;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = [0.22, 1, 0.36, 1];
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== delay) {
    t16 = {
      duration: 0.6,
      delay,
      ease: t15 as const
    };
    $[31] = delay;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== children || $[34] !== className || $[35] !== t13 || $[36] !== t14 || $[37] !== t16) {
    t17 = <motion.div ref={ref} initial={t13} animate={t14} transition={t16} className={className}>{children}</motion.div>;
    $[33] = children;
    $[34] = className;
    $[35] = t13;
    $[36] = t14;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
}